import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { utilTime } from "../../utils/utilTime";
export var MessageDetails = React.memo(function (_a) {
    var messageInfo = _a.messageInfo;
    var proto = messageInfo.proto;
    var age = utilTime.ageFromCreationDate(proto.creationTimestamp);
    return (React.createElement("div", { className: "chat-message-container w100" },
        React.createElement("div", { className: "flex flex--spaced" },
            React.createElement("div", { className: IdStyles.TextBoldPrimary }, proto.playerName),
            React.createElement("div", { className: "chat-message-age " + IdStyles.TextSmall }, age)),
        React.createElement("div", { className: IdStyles.TextNormal + " overflow-break-word" }, proto.originalMessage)));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/MessageDetails.tsx
// module id = 914
// module chunks = 3